//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GridCardComponent from '@/components/work_environments/GridCardComponent';
export default {
  name: 'Somos1Home',
  components: {
    GridCardComponent: GridCardComponent
  },
  data: function data() {
    return {};
  },
  created: function created() {
    this.setAccess();
  },
  computed: {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('menu.customer.home'),
        disabled: false,
        href: '/#/customer_insights/home'
      }, {
        text: this.translate('menu.customer.somos1'),
        disabled: true,
        href: ''
      }];
    },
    cards: function cards() {
      return [{
        title_es: 'Dataentry',
        title_en: 'Dataentry',
        subtitle_es: 'Carga de indicadores de su organización en las regiones en la que se encuentre presente',
        subtitle_en: 'Load indicators of your organization in the regions where it is present',
        color: '#F1F1F1',
        image: 'UploadData.png',
        flex: 4,
        path: '/customer_insights/data_entry',
        access: false
      }, {
        title_es: 'Reportes',
        title_en: 'Reports',
        subtitle_es: 'Reportes Insights, Somos 1 y Métricas de Uso',
        subtitle_en: 'Insights, Somos 1 and Usage Metrics Reports',
        color: '#F1F1F1',
        image: 'Presentation.png',
        flex: 4,
        path: '/customer_insights/somos1',
        access: false
      }, {
        title_es: 'Seguimiento dataentry',
        title_en: 'Dataentry Follow-up',
        subtitle_es: 'Seguimiento a la carga de Indicadores',
        subtitle_en: 'Tracking of the load of Indicators',
        color: '#F1F1F1',
        image: 'Request.png',
        flex: 4,
        path: '/customer_insights/tracking_dataentry',
        access: false
      }];
    }
  },
  methods: {
    setAccess: function setAccess() {
      this.cards[0].access = !!(this.userHasRole(this.rolesINCA.INSIGHTS_ADMIN) || this.userHasRole(this.rolesINCA.ORG_DATA_STEWARD) || this.userHasRole(this.rolesINCA.INSIGHTS_SOMOS1_DATA_ENTRY_USER) || this.userHasRole(this.rolesINCA.INSIGHTS_SOMOS1_CORP_VIEWER));
      this.cards[1].access = !!(this.userHasRole(this.rolesINCA.INSIGHTS_ADMIN) || this.userHasRole(this.rolesINCA.ORG_DATA_STEWARD) || this.userHasRole(this.rolesINCA.INSIGHTS_USER_SOMOS1) || this.userHasRole(this.rolesINCA.INSIGHTS_SOMOS1_CORP_VIEWER) || this.userHasRole(this.rolesINCA.INSIGHTS_BUSINESS_USER));
      this.cards[2].access = !!(this.userHasRole(this.rolesINCA.INSIGHTS_ADMIN) || this.userHasRole(this.rolesINCA.ORG_DATA_STEWARD) || this.userHasRole(this.rolesINCA.INSIGHTS_SOMOS1_CORP_VIEWER));
    }
  }
};